import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE_AGENT } from '@utils/helpers'

const measureListAgentRoutes = {
  path: 'measure-list-agent',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.measureAgent.list'),
  },
  children: [
    {
      path: '',
      name: 'measureListAgent',
      component: () => lazyLoadView(import('@views/MeasureListAgent/list.vue')),
      meta: {
        authRequired: ROLE_AGENT,
      },
    },
  ],
}

export default measureListAgentRoutes
